import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle, XCircle, Award, BookOpen, AlertTriangle, RotateCcw, ExternalLink, ShoppingCart, LogIn } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Badge } from '../ui/badge';
import { Progress } from '../ui/progress';
import Header from '../Header';
import Footer from '../Footer';
import LoginModal from '../LoginModal';
import SEO from '../SEO';
import { useAuth } from '../../context/AuthContext';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// Logo base64 para o certificado (movido para fora do componente)
const companyLogoBase64 = 'data:image/png;base64,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';

// Mapeamento de cursos relacionados com IDs reais do sistema (usando bundles/formações)
const courseMapping = {
  'Revit Arquitetura Avançado': {
    id: 3,
    type: 'bundle',
    name: 'Formação Revit Expert | Arquitetura',
    description: 'Formação completa incluindo Arquitetura Avançada, Projetos Complexos e muito mais',
    price: 'A partir de R$ 7.997,00'
  },
  'Revit Bibliotecas e Famílias': {
    id: 3,
    type: 'bundle',
    name: 'Formação Revit Expert | Arquitetura',
    description: 'Formação completa incluindo Bibliotecas, Famílias e Parametrização',
    price: 'A partir de R$ 7.997,00'
  },
  'Revit Parametrização': {
    id: 3,
    type: 'bundle',
    name: 'Formação Revit Expert | Arquitetura',
    description: 'Formação completa incluindo Parametrização de Famílias e Parâmetros Compartilhados',
    price: 'A partir de R$ 7.997,00'
  }
};

// Função auxiliar para agrupar cursos recomendados por bundle ID
const getRecommendedCourses = (wrongAnswers) => {
  const bundleMap = {};
  wrongAnswers.forEach(wa => {
    const courseInfo = courseMapping[wa.relatedCourse];
    const bundleId = courseInfo?.id || 3;
    
    if (!bundleMap[bundleId]) {
      bundleMap[bundleId] = {
        bundleId: bundleId,
        bundleInfo: courseInfo,
        categories: new Set(),
        relatedCourses: new Set(),
        count: 0,
        questions: []
      };
    }
    bundleMap[bundleId].categories.add(wa.category);
    bundleMap[bundleId].relatedCourses.add(wa.relatedCourse);
    bundleMap[bundleId].count++;
    bundleMap[bundleId].questions.push(wa);
  });
  
  // Converter Sets para Arrays para exibição
  return Object.values(bundleMap).map(item => ({
    ...item,
    categories: Array.from(item.categories),
    relatedCourses: Array.from(item.relatedCourses)
  })).sort((a, b) => b.count - a.count);
};

// Componente de questões erradas e cursos recomendados (extraído para evitar re-criação)
const WrongAnswersAndCourses = ({ wrongAnswers, showTitle = true, navigate }) => {
  const recommendedCourses = getRecommendedCourses(wrongAnswers);
  
  if (wrongAnswers.length === 0) return null;
  
  return (
    <>
      {/* Questões Erradas */}
      <Card className="bg-zinc-900 border-zinc-800 mb-8">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <AlertTriangle className="text-yellow-500" />
            {showTitle ? `Questões que precisam de atenção (${wrongAnswers.length})` : `Você errou ${wrongAnswers.length} questões`}
          </CardTitle>
          <CardDescription className="text-gray-400">
            Revise os temas abaixo para aprimorar seus conhecimentos
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {wrongAnswers.map((wa, index) => (
              <div key={wa.id} className="bg-zinc-800 rounded-lg p-4">
                <div className="flex items-start gap-3">
                  <span className="text-red-400 font-bold">{index + 1}.</span>
                  <div>
                    <Badge className="bg-zinc-700 text-gray-300 mb-2">{wa.category}</Badge>
                    <p className="text-gray-300 text-sm">{wa.question}</p>
                    <p className="text-red-400 text-xs mt-2">
                      Sua resposta: {wa.userAnswer}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Cursos Recomendados */}
      <Card className="bg-gradient-to-br from-blue-900/30 to-zinc-900 border-blue-500/30 mb-8">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <BookOpen className="text-blue-400" />
            Formação Recomendada para Você
          </CardTitle>
          <CardDescription className="text-gray-400">
            Com base nas questões que você não acertou, recomendamos a formação abaixo para aprimorar seus conhecimentos
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {recommendedCourses.map((bundleData, index) => {
              const bundleInfo = bundleData.bundleInfo;
              return (
                <div key={index} className="bg-zinc-900 rounded-xl p-6 border border-zinc-800">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <h4 className="text-white font-bold text-lg">{bundleInfo?.name || 'Formação Revit Expert | Arquitetura'}</h4>
                        <Badge className="bg-red-600/20 text-red-400 border-red-500/30">
                          {bundleData.count} questões relacionadas
                        </Badge>
                      </div>
                      
                      {/* Áreas de melhoria */}
                      <div className="flex flex-wrap gap-2 mb-3">
                        {bundleData.categories.map((cat, catIndex) => (
                          <Badge key={catIndex} className="bg-blue-600/20 text-blue-400 border-blue-500/30">
                            {cat}
                          </Badge>
                        ))}
                      </div>
                      
                      <p className="text-gray-400 text-sm mb-3">
                        {bundleInfo?.description || 'Formação completa para aprimorar seus conhecimentos'}
                      </p>
                      <p className="text-green-400 font-bold">
                        {bundleInfo?.price || 'A partir de R$ 7.997,00'}
                      </p>
                    </div>
                    <div className="flex flex-col sm:flex-row gap-3">
                      <Button
                        onClick={() => navigate(`/course/${bundleData.bundleId}`)}
                        variant="outline"
                        className="border-zinc-700 text-white hover:bg-zinc-800"
                      >
                        <ExternalLink className="mr-2" size={16} />
                        Ver Detalhes
                      </Button>
                      <Button
                        onClick={() => navigate(`/checkout/${bundleData.bundleId}/ead_recorded`)}
                        className="bg-red-600 hover:bg-red-700"
                      >
                        <ShoppingCart className="mr-2" size={16} />
                        Matricular-se
                      </Button>
                    </div>
                  </div>
                  
                  {/* Questões relacionadas a este curso */}
                  <div className="mt-4 pt-4 border-t border-zinc-800">
                    <p className="text-gray-500 text-xs mb-2">Questões relacionadas:</p>
                    <div className="flex flex-wrap gap-2">
                      {bundleData.questions.map((q, qIndex) => (
                        <span key={qIndex} className="text-xs bg-zinc-800 text-gray-400 px-2 py-1 rounded">
                          Q{q.id}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>
    </>
  );
};

const RevitAssessmentPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [isGeneratingCertificate, setIsGeneratingCertificate] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const certificateRef = useRef(null);

  // Perguntas sobre Revit - Arquitetura Avançado, Bibliotecas e Parametrização
  const questions = [
    // Arquitetura Avançado (8 perguntas)
    {
      id: 1,
      category: 'Arquitetura Avançado',
      question: 'Qual é a função principal do comando "Copiar/Monitorar" no Revit?',
      options: [
        'Duplicar elementos entre projetos',
        'Monitorar alterações em elementos vinculados de outros modelos',
        'Criar cópias de backup do projeto',
        'Rastrear modificações feitas por outros usuários'
      ],
      correct: 1,
      relatedCourse: 'Revit Arquitetura Avançado'
    },
    {
      id: 2,
      category: 'Arquitetura Avançado',
      question: 'No Revit, o que são "Fases" e para que servem?',
      options: [
        'Etapas do processo de renderização',
        'Divisões do projeto em arquivos separados',
        'Representação de diferentes momentos construtivos do projeto (existente, demolição, novo)',
        'Níveis de detalhamento do modelo'
      ],
      correct: 2,
      relatedCourse: 'Revit Arquitetura Avançado'
    },
    {
      id: 3,
      category: 'Arquitetura Avançado',
      question: 'Qual ferramenta do Revit permite criar formas complexas não convencionais?',
      options: [
        'Muro Cortina',
        'Massa Conceitual',
        'Piso Inclinado',
        'Telhado por Extrusão'
      ],
      correct: 1,
      relatedCourse: 'Revit Arquitetura Avançado'
    },
    {
      id: 4,
      category: 'Arquitetura Avançado',
      question: 'O que é um "Workset" no Revit?',
      options: [
        'Um conjunto de ferramentas de trabalho',
        'Uma área de trabalho colaborativo que permite dividir o modelo entre usuários',
        'Um template de projeto',
        'Uma vista específica do modelo'
      ],
      correct: 1,
      relatedCourse: 'Revit Arquitetura Avançado'
    },
    {
      id: 5,
      category: 'Arquitetura Avançado',
      question: 'Qual é a diferença entre "Grupo" e "Conjunto de Seleção" no Revit?',
      options: [
        'Não há diferença, são sinônimos',
        'Grupo mantém a relação entre elementos, Conjunto de Seleção é apenas uma seleção temporária',
        'Grupo é para elementos 2D, Conjunto de Seleção é para 3D',
        'Grupo não pode ser editado, Conjunto de Seleção pode'
      ],
      correct: 1,
      relatedCourse: 'Revit Arquitetura Avançado'
    },
    {
      id: 6,
      category: 'Arquitetura Avançado',
      question: 'No contexto de Design Options, qual afirmação é correta?',
      options: [
        'Só é possível ter uma opção de design por projeto',
        'Design Options permite criar variações de projeto dentro do mesmo arquivo',
        'Design Options é usado apenas para renderização',
        'Design Options substitui o uso de fases'
      ],
      correct: 1,
      relatedCourse: 'Revit Arquitetura Avançado'
    },
    {
      id: 7,
      category: 'Arquitetura Avançado',
      question: 'O que é o "Model In-Place" e quando deve ser utilizado?',
      options: [
        'É um comando para importar modelos externos',
        'É uma família criada dentro do projeto para geometrias únicas e específicas',
        'É uma ferramenta de modelagem de terreno',
        'É um tipo de vista do projeto'
      ],
      correct: 1,
      relatedCourse: 'Revit Arquitetura Avançado'
    },
    {
      id: 8,
      category: 'Arquitetura Avançado',
      question: 'Qual é a função do "Assembly" no Revit?',
      options: [
        'Criar animações do modelo',
        'Agrupar elementos para documentação e quantificação específica',
        'Importar arquivos de outros softwares',
        'Configurar o ambiente de trabalho'
      ],
      correct: 1,
      relatedCourse: 'Revit Arquitetura Avançado'
    },
    // Bibliotecas (6 perguntas)
    {
      id: 9,
      category: 'Bibliotecas',
      question: 'Qual é a extensão de arquivo de uma família do Revit?',
      options: [
        '.rvt',
        '.rfa',
        '.rte',
        '.dwg'
      ],
      correct: 1,
      relatedCourse: 'Revit Bibliotecas e Famílias'
    },
    {
      id: 10,
      category: 'Bibliotecas',
      question: 'O que são famílias "Carregáveis" no Revit?',
      options: [
        'Famílias que vêm pré-instaladas no Revit',
        'Famílias criadas externamente que podem ser carregadas no projeto',
        'Famílias que não podem ser editadas',
        'Famílias apenas para visualização'
      ],
      correct: 1,
      relatedCourse: 'Revit Bibliotecas e Famílias'
    },
    {
      id: 11,
      category: 'Bibliotecas',
      question: 'Qual a diferença entre famílias de sistema e famílias carregáveis?',
      options: [
        'Famílias de sistema são mais leves',
        'Famílias de sistema são predefinidas e modificadas dentro do projeto, carregáveis são criadas externamente',
        'Não há diferença significativa',
        'Famílias carregáveis são apenas para MEP'
      ],
      correct: 1,
      relatedCourse: 'Revit Bibliotecas e Famílias'
    },
    {
      id: 12,
      category: 'Bibliotecas',
      question: 'O que é um "Tipo" dentro de uma família do Revit?',
      options: [
        'A categoria da família',
        'Uma variação da família com parâmetros específicos',
        'O nome do arquivo da família',
        'A versão do Revit compatível'
      ],
      correct: 1,
      relatedCourse: 'Revit Bibliotecas e Famílias'
    },
    {
      id: 13,
      category: 'Bibliotecas',
      question: 'Qual comando é usado para criar uma nova família a partir de um template?',
      options: [
        'Arquivo > Novo > Projeto',
        'Arquivo > Novo > Família',
        'Inserir > Carregar Família',
        'Criar > Componente'
      ],
      correct: 1,
      relatedCourse: 'Revit Bibliotecas e Famílias'
    },
    {
      id: 14,
      category: 'Bibliotecas',
      question: 'O que acontece quando você edita uma família carregada no projeto?',
      options: [
        'A família original no disco é alterada automaticamente',
        'Apenas a instância selecionada é modificada',
        'Todas as instâncias daquela família no projeto são atualizadas após recarregar',
        'O projeto é corrompido'
      ],
      correct: 2,
      relatedCourse: 'Revit Bibliotecas e Famílias'
    },
    // Parametrização (6 perguntas)
    {
      id: 15,
      category: 'Parametrização',
      question: 'Qual é a diferença entre parâmetros de "Tipo" e parâmetros de "Instância"?',
      options: [
        'Parâmetros de Tipo afetam todas as instâncias do tipo, parâmetros de Instância são únicos para cada elemento',
        'Não há diferença',
        'Parâmetros de Tipo são apenas numéricos',
        'Parâmetros de Instância não podem ser editados'
      ],
      correct: 0,
      relatedCourse: 'Revit Parametrização'
    },
    {
      id: 16,
      category: 'Parametrização',
      question: 'O que é um "Parâmetro Compartilhado" no Revit?',
      options: [
        'Um parâmetro visível apenas para administradores',
        'Um parâmetro que pode ser usado em várias famílias e em tabelas',
        'Um parâmetro que é compartilhado via nuvem',
        'Um parâmetro que só funciona em trabalho colaborativo'
      ],
      correct: 1,
      relatedCourse: 'Revit Parametrização'
    },
    {
      id: 17,
      category: 'Parametrização',
      question: 'Qual tipo de parâmetro permite criar fórmulas no Revit?',
      options: [
        'Texto',
        'Sim/Não',
        'Numérico (Comprimento, Área, Número, etc.)',
        'URL'
      ],
      correct: 2,
      relatedCourse: 'Revit Parametrização'
    },
    {
      id: 18,
      category: 'Parametrização',
      question: 'O que é um "Parâmetro Global" no Revit?',
      options: [
        'Um parâmetro visível em todos os projetos',
        'Um parâmetro que controla valores em todo o projeto, não vinculado a famílias específicas',
        'Um parâmetro de configuração do software',
        'Um parâmetro que não pode ser alterado'
      ],
      correct: 1,
      relatedCourse: 'Revit Parametrização'
    },
    {
      id: 19,
      category: 'Parametrização',
      question: 'Qual função do Revit permite vincular parâmetros a cotas?',
      options: [
        'Anotação Automática',
        'Restrições Dimensionais',
        'Cotas Parametrizadas com Labels',
        'Cotagem Inteligente'
      ],
      correct: 2,
      relatedCourse: 'Revit Parametrização'
    },
    {
      id: 20,
      category: 'Parametrização',
      question: 'O que acontece quando você define um parâmetro como "Parâmetro de Relatório"?',
      options: [
        'O parâmetro é exportado automaticamente para Excel',
        'O parâmetro se torna somente leitura e seu valor é calculado pelo Revit',
        'O parâmetro aparece em todos os relatórios',
        'O parâmetro é compartilhado com outros projetos'
      ],
      correct: 1,
      relatedCourse: 'Revit Parametrização'
    }
  ];

  const handleAnswer = (questionId, answerIndex) => {
    setAnswers(prev => ({ ...prev, [questionId]: answerIndex }));
  };

  const calculateResults = () => {
    let score = 0;
    const wrongAnswers = [];
    
    questions.forEach(q => {
      if (answers[q.id] === q.correct) {
        score++;
      } else {
        wrongAnswers.push({
          id: q.id,
          question: q.question,
          category: q.category,
          relatedCourse: q.relatedCourse,
          userAnswer: answers[q.id] !== undefined ? q.options[answers[q.id]] : 'Não respondida'
        });
      }
    });

    return {
      score,
      total: questions.length,
      passed: score >= 8,
      wrongAnswers
    };
  };

  const handleSubmit = () => {
    if (!user) {
      setIsLoginModalOpen(true);
      return;
    }
    setShowResults(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleRetry = () => {
    setAnswers({});
    setShowResults(false);
  };

  const generateCertificate = async () => {
    if (!certificateRef.current || !user) return;
    
    setIsGeneratingCertificate(true);
    try {
      const canvas = await html2canvas(certificateRef.current, {
        scale: 2,
        backgroundColor: '#000000',
        useCORS: true
      });
      
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('landscape', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(`Certificado_Revit_${user.name.replace(/\s/g, '_')}.pdf`);
    } catch (error) {
    } finally {
      setIsGeneratingCertificate(false);
    }
  };

  const results = showResults ? calculateResults() : null;
  const progress = (Object.keys(answers).length / questions.length) * 100;

  if (showResults && results) {
    return (
      <div className="min-h-screen bg-black">
        <Header />
        <main className="pt-24 pb-12">
          <div className="container mx-auto px-4 lg:px-8">
            <div className="max-w-4xl mx-auto">
              
              {results.passed ? (
                <>
                  {/* Resultado - Aprovado */}
                  <div className="text-center mb-12">
                    <div className="w-24 h-24 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                      <Award className="text-white" size={48} />
                    </div>
                    <h1 className="text-4xl font-bold text-green-400 mb-4">Parabéns, {user?.name}!</h1>
                    <p className="text-2xl text-white mb-2">Você foi aprovado!</p>
                    <p className="text-xl text-gray-300">
                      Sua pontuação: <span className="text-green-400 font-bold">{results.score}</span> de {results.total} pontos
                    </p>
                  </div>

                  {/* Certificado */}
                  <div className="mb-8">
                    <div 
                      ref={certificateRef}
                      className="bg-gradient-to-br from-zinc-900 via-black to-zinc-900 border-4 border-yellow-500 rounded-lg p-12 text-center"
                    >
                      <div className="border-2 border-yellow-500/50 rounded-lg p-8">
                        <img 
                          src={companyLogoBase64} 
                          alt="AJ BIM Academy" 
                          className="h-16 mx-auto mb-6"
                        />
                        <p className="text-yellow-500 text-sm uppercase tracking-widest mb-4">Certificado de Aprovação</p>
                        <h2 className="text-3xl font-bold text-white mb-6">AJ | BIM ACADEMY</h2>
                        <p className="text-gray-300 mb-2">Certifica que</p>
                        <h3 className="text-2xl font-bold text-yellow-400 mb-4">{user?.name || 'Participante'}</h3>
                        <p className="text-gray-300 mb-6">foi aprovado(a) na</p>
                        <h3 className="text-xl font-bold text-white mb-4">
                          Avaliação de Conhecimentos em Autodesk Revit
                        </h3>
                        <p className="text-gray-400 mb-2">Arquitetura Avançado | Bibliotecas | Parametrização</p>
                        <p className="text-white text-xl font-bold mb-6">
                          Pontuação: {results.score}/{results.total}
                        </p>
                        <p className="text-gray-500 text-sm">
                          Data: {new Date().toLocaleDateString('pt-BR')}
                        </p>
                        <p className="text-gray-600 text-xs mt-4">www.bimportal.com.br</p>
                      </div>
                    </div>
                  </div>

                  <div className="text-center mb-12">
                    <Button
                      onClick={generateCertificate}
                      disabled={isGeneratingCertificate}
                      className="bg-yellow-600 hover:bg-yellow-700 text-black font-bold px-8 py-3"
                    >
                      {isGeneratingCertificate ? 'Gerando...' : 'Baixar Certificado PDF'}
                    </Button>
                  </div>

                  {/* Questões erradas e cursos recomendados (mesmo aprovado) */}
                  {results.wrongAnswers.length > 0 && (
                    <>
                      <div className="border-t border-zinc-800 pt-8 mb-8">
                        <h2 className="text-2xl font-bold text-white text-center mb-6">
                          Ainda pode melhorar!
                        </h2>
                        <p className="text-gray-400 text-center mb-8">
                          Mesmo aprovado, você pode aprimorar seus conhecimentos nas áreas abaixo:
                        </p>
                      </div>
                      <WrongAnswersAndCourses wrongAnswers={results.wrongAnswers} showTitle={false} navigate={navigate} />
                    </>
                  )}
                </>
              ) : (
                <>
                  {/* Resultado - Não Aprovado */}
                  <div className="text-center mb-12">
                    <div className="w-24 h-24 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                      <XCircle className="text-white" size={48} />
                    </div>
                    <h1 className="text-4xl font-bold text-red-400 mb-4">
                      {user?.name}, você não atingiu a pontuação mínima
                    </h1>
                    <p className="text-xl text-gray-300 mb-2">
                      Sua pontuação: <span className="text-red-400 font-bold">{results.score}</span> de {results.total} pontos
                    </p>
                    <p className="text-gray-400">Mínimo necessário: 8 pontos</p>
                  </div>

                  {/* Questões erradas e cursos recomendados */}
                  <WrongAnswersAndCourses wrongAnswers={results.wrongAnswers} navigate={navigate} />

                  <div className="text-center">
                    <Button
                      onClick={handleRetry}
                      variant="outline"
                      className="border-zinc-700 text-white mr-4"
                    >
                      <RotateCcw className="mr-2" size={18} />
                      Tentar Novamente
                    </Button>
                    <Button
                      onClick={() => navigate('/')}
                      className="bg-red-600 hover:bg-red-700"
                    >
                      Ver Todos os Cursos
                    </Button>
                  </div>
                </>
              )}

              {/* Botão Voltar */}
              <div className="text-center mt-12">
                <Button
                  onClick={() => navigate('/')}
                  variant="outline"
                  className="border-zinc-700 text-white"
                >
                  <ArrowLeft className="mr-2" size={18} />
                  Voltar ao Início
                </Button>
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black">
      <SEO 
        title="Avaliação de Conhecimento em Revit"
        description="Teste seus conhecimentos em Autodesk Revit. Avalie seu nível em Arquitetura Avançada, Bibliotecas e Parametrização. Receba certificado ao passar ou recomendações de cursos personalizadas."
        keywords="teste Revit, avaliação Revit, quiz BIM, certificado Revit, conhecimento Autodesk"
      />
      <Header />
      <LoginModal 
        isOpen={isLoginModalOpen} 
        onClose={() => setIsLoginModalOpen(false)} 
      />
      <main className="pt-24 pb-12">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto">
            {/* Header */}
            <div className="text-center mb-12">
              <Button
                onClick={() => navigate('/')}
                variant="ghost"
                className="text-gray-400 hover:text-white mb-6"
              >
                <ArrowLeft className="mr-2" size={20} />
                Voltar ao Início
              </Button>
              
              <Badge className="bg-red-600/20 text-red-400 border-red-500/30 mb-4">
                Avaliação de Conhecimentos
              </Badge>
              <h1 className="text-4xl font-bold text-white mb-4">
                Teste seu Conhecimento em <span className="text-red-500">Revit</span>
              </h1>
              <p className="text-gray-400 max-w-2xl mx-auto">
                Avalie seus conhecimentos em Autodesk Revit nas áreas de Arquitetura Avançado, 
                Bibliotecas e Parametrização. São 20 questões de múltipla escolha.
              </p>
            </div>

            {/* Aviso de Login */}
            {!user && (
              <Card className="bg-yellow-900/20 border-yellow-500/30 mb-8">
                <CardContent className="pt-6">
                  <div className="flex items-center gap-4">
                    <LogIn className="text-yellow-500" size={24} />
                    <div>
                      <p className="text-yellow-400 font-medium">Faça login para receber seu certificado</p>
                      <p className="text-gray-400 text-sm">
                        Para gerar o certificado com seu nome, é necessário estar logado.
                      </p>
                    </div>
                    <Button
                      onClick={() => setIsLoginModalOpen(true)}
                      className="bg-yellow-600 hover:bg-yellow-700 text-black ml-auto"
                    >
                      Fazer Login
                    </Button>
                  </div>
                </CardContent>
              </Card>
            )}

            {/* Usuário logado */}
            {user && (
              <Card className="bg-green-900/20 border-green-500/30 mb-8">
                <CardContent className="pt-6">
                  <div className="flex items-center gap-4">
                    <CheckCircle className="text-green-500" size={24} />
                    <div>
                      <p className="text-green-400 font-medium">Olá, {user.name}!</p>
                      <p className="text-gray-400 text-sm">
                        Seu certificado será gerado com este nome ao ser aprovado.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )}

            {/* Informações */}
            <div className="grid md:grid-cols-3 gap-4 mb-8">
              <Card className="bg-zinc-900 border-zinc-800">
                <CardContent className="pt-6 text-center">
                  <p className="text-3xl font-bold text-white">20</p>
                  <p className="text-gray-400 text-sm">Questões</p>
                </CardContent>
              </Card>
              <Card className="bg-zinc-900 border-zinc-800">
                <CardContent className="pt-6 text-center">
                  <p className="text-3xl font-bold text-green-400">8.0</p>
                  <p className="text-gray-400 text-sm">Mínimo para Aprovação</p>
                </CardContent>
              </Card>
              <Card className="bg-zinc-900 border-zinc-800">
                <CardContent className="pt-6 text-center">
                  <p className="text-3xl font-bold text-yellow-400">🏆</p>
                  <p className="text-gray-400 text-sm">Certificado ao Passar</p>
                </CardContent>
              </Card>
            </div>

            {/* Progresso */}
            <div className="mb-8">
              <div className="flex justify-between text-sm text-gray-400 mb-2">
                <span>Progresso</span>
                <span>{Object.keys(answers).length} de {questions.length} respondidas</span>
              </div>
              <Progress value={progress} className="h-2" />
            </div>

            {/* Questões */}
            <div className="space-y-6">
              {questions.map((q, index) => (
                <Card 
                  key={q.id} 
                  className={`bg-zinc-900 border-zinc-800 ${answers[q.id] !== undefined ? 'border-green-500/30' : ''}`}
                >
                  <CardHeader>
                    <div className="flex items-center justify-between">
                      <Badge className="bg-zinc-800 text-gray-300">{q.category}</Badge>
                      <span className="text-gray-500 text-sm">Questão {index + 1}</span>
                    </div>
                    <CardTitle className="text-white text-lg mt-2">{q.question}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      {q.options.map((option, optIndex) => (
                        <button
                          key={optIndex}
                          onClick={() => handleAnswer(q.id, optIndex)}
                          className={`w-full text-left p-4 rounded-lg border transition-all ${
                            answers[q.id] === optIndex
                              ? 'bg-red-600/20 border-red-500 text-white'
                              : 'bg-zinc-800 border-zinc-700 text-gray-300 hover:border-zinc-600'
                          }`}
                        >
                          <span className="font-medium mr-2">
                            {String.fromCharCode(65 + optIndex)}.
                          </span>
                          {option}
                        </button>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>

            {/* Botão Finalizar */}
            <div className="mt-12 text-center">
              <Button
                onClick={handleSubmit}
                disabled={Object.keys(answers).length < questions.length}
                className="bg-red-600 hover:bg-red-700 px-12 py-6 text-lg"
              >
                <CheckCircle className="mr-2" size={24} />
                Finalizar Avaliação
              </Button>
              {Object.keys(answers).length < questions.length && (
                <p className="text-gray-500 text-sm mt-4">
                  Responda todas as {questions.length - Object.keys(answers).length} questões restantes para finalizar
                </p>
              )}
              {!user && Object.keys(answers).length === questions.length && (
                <p className="text-yellow-400 text-sm mt-4">
                  Você será solicitado a fazer login para ver seus resultados e gerar o certificado
                </p>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RevitAssessmentPage;
